export default {"src":"/_next/static/media/vision.e5a75cba.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};